/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { Map, Record } from 'immutable';

export interface SalesCommissionState extends Map<string, any> {

  commissionList: any;
  commissionListLoading: boolean;
  commissionListLoaded: boolean;
  commissionListFailed: boolean;

  commissionListCount: any;
  commissionListCountLoading: boolean;
  commissionListCountLoaded: boolean;
  commissionListCountFailed: boolean;

  makeCommissionArchive: any;
  makeCommissionArchiveLoading: boolean;
  makeCommissionArchiveLoaded: boolean;
  makeCommissionArchiveFailed: boolean;
}

export const SalesCommissionStateRecord = Record({

    commissionList: [],
    commissionListLoading: false,
    commissionListLoaded: false,
    commissionListFailed: false,

    commissionListCount: [],
    commissionListCountLoading: false,
    commissionListCountLoaded: false,
    commissionListCountFailed: false
});